import { useTranslation } from 'react-i18next';

export function FullScreenLoader() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-base">
      <div className="flex flex-col items-center gap-4">
        <span aria-hidden className="block h-10 w-10 animate-spin rounded-full border-2 border-line border-t-accent" />
        <div className="text-[12px] tracking-[0.04em] text-muted">{t('onboarding.appLoader')}</div>
      </div>
    </div>
  );
}
